import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { rolesParaInspeccion, rolesParaRevisor } from './permisosMenusRutas';



// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'redirect' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'redirect' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
            { path: 'confirmacion-email', loadChildren: () => import('app/modules/auth/confirm-email/confirm-email.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
            { path: 'redirect', loadChildren: () => import('app/shared/redirect/redirect.routes') },
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'homex', loadChildren: () => import('app/modules/landing/home/home.routes') },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [

            {
                path: 'usuarioform', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/usuarioform/usuarioform.routes')
            },
            {
                path: 'usuarioform/:login', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/usuarioform/usuarioform.routes')
            },
            {
                path: 'tablausuario', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/tablausuario/tablausuario.routes')
            },
            {
                path: 'domicilioform', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/domicilioform/domicilioform.routes')
            },
            {
                path: 'domicilioform/:id', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/domicilioform/domicilioform.routes')
            },
            {
                path: 'tabladomicilio', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/tabladomicilio/tabladomicilio.routes')
            },
            {
                path: 'scianform', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/sianform/sianform.routes')
            },
            {
                path: 'scianform/:id', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/sianform/sianform.routes')
            },
            {
                path: 'tablasian', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/tablasian/tablasian.routes')
            },
            {
                path: 'tablacategorias', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/tabla-categorias/tabla-categorias.routes')
            },
            {
                path: 'tablacategorias-requisitos', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/tabla-categorias-requisitos/tabla-categorias-requisitos.routes')
            },
            {
                path: 'categorias-form/:id', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/categorias-form/categorias-form.routes')
            },
            {
                path: 'categorias-form', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/categorias-form/categorias-form.routes')
            },
            {
                path: 'categorias-requisitos-form/:id', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/categorias-requisitos-form/categorias-requisitos-form.routes')
            },
            {
                path: 'categorias-requisitos-form', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/categorias-requisitos-form/categorias-requisitos-form.routes')
            },
            { path: 'finspeccionform', loadChildren: () => import('app/modules/inspector/finspeccionform/finspeccionform.routes') },
            {
                path: 'documentosform', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/documentosform/documentosform.routes')
            },
            {
                path: 'documentosform/:id', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/documentosform/documentosform.routes')
            },
            {
                path: 'tramite-requisito', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/rtramiteform/rtramiteform.routes')
            },
            {
                path: 'tramite-requisito/:id', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/rtramiteform/rtramiteform.routes')
            },
            {
                path: 'tabla-documentos', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/tabla-documentos/tabla-documentos.routes')
            },
            {
                path: 'tabla-tramites-requisitos', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN',"ROLE_CATALOGOS"],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/tabla-tramites-requisitos/tabla-tramites-requisitos.routes')
            },


            {
                path: 'usuario-dashboard', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/usuario/dashboard/usuario-dashboard.routes')
            },
            {
                path: 'alta', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/alta/alta.routes')
            },
            {
                path: 'refrendo', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/usuario/refrendo/refrendo.routes')
            },
            {
                path: 'refrendo-actualizaciones', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/usuario/refrendo-actualizaciones/refrendo-actualizaciones.routes')
            },
            {
                path: 'refrendo-cd', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/alta-refrendo-sd/refrendo-sd.routes')
            },
            {
                path: 'solicitudes', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: [...rolesParaRevisor],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/solicitudes/solicitudes.routes')
            },
            {
                path: 'revisor', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: [...rolesParaRevisor],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/revisor/revisor.routes')
            },
            {
                path: 'dashrevisor', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: [...rolesParaRevisor],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/dashrevisor/dashrevisor.routes')
            },
            {
                path: 'dashinspector', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: [...rolesParaInspeccion],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/inspector/dashinspector/dashinspector.routes')
            },
            {
                path: 'inspector-solicitud', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: [...rolesParaInspeccion],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/inspector/inspector-solicitud/inspector-solicitud.routes')
            },
            { path: 'pago', loadChildren: () => import('app/modules/admin/pago/pago.routes') },
            {
                path: 'solicitud-alta-empresa', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/usuario/solicitud-alta-empresa/solicitud-alta-empresa.routes')
            },
            {
                path: 'solicitud-actualizaciones', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/usuario/solicitud-actualizaciones/solicitud-actualizaciones.routes')
            },
            {
                path: 'solicitud-refrendo', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/usuario/solicitud-refrendo/solicitud-refrendo-empresa.routes')
            },
            {
                path: 'solicitud-refrendo-cd', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_USER'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/usuario/solicitud-refrendo-sd/solicitud-refrendo-sd.routes')
            },
            {
                path: 'refrendo-revisor', canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN', 'ROLE_REVISOR_FOMENTO', 'ROLE_SUPERVISOR_FOMENTO', 'ROLE_JEFE_DEPARTAMENTO'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/modules/admin/solicitud-refrendo-revisor/solicitud-refrendo-revisor.routes')
            },
            { path: 'usuario-pagos', loadChildren: () => import('app/modules/usuario/pagos/usuario-pagos.routes') },
            { path: 'usuario-dictamenes', loadChildren: () => import('app/modules/usuario/dictamenes/usuario-dictamenes.routes') },
            { path: 'dictamenes', loadChildren: () => import('app/modules/admin/dictamenes/funcionario-dictamenes.routes') },
            {
                path: 'usuarios',
                canActivate: [NgxPermissionsGuard], data: {
                    permissions: {
                        only: ['ROLE_ADMIN'],
                        redirectTo: '/redirect'
                    }
                }, loadChildren: () => import('app/entities/user-management/users.module').then(m => m.UserManagementModule)
            }
        ]
    },
    { path: '**', loadChildren: () => import('app/modules/error/error-404/error-404.module').then(m => m.Error404Module) }
];



